import {Injectable, signal} from '@angular/core';
import { JwtHelperService } from "@auth0/angular-jwt";
import * as CryptoJS from "crypto-js";

import { HttpClient, HttpHeaders } from "@angular/common/http";

@Injectable()
export class ToolsBoxService {

  //Configuration parameters //////////////////////////////////
  currentVersion = '4.1.0';
  localAddress = "http://localhost:8080/api";
  //////////////////////////////////////////////////////////////
  currentEnvironment: string;
  backEndUrl: string;
  backEndReleaseNote: string;

  // Signals replacing the EventEmitter anti-patterns
  readonly backEndVersion   = signal<string>('');
  readonly pageName         = signal<string>('Dashboard');
  readonly containsTabs     = signal<boolean>(false);
  readonly actionInProgress = signal<boolean>(false);
  readonly avatar           = signal<string>('');
  readonly isLoggedIn       = signal<boolean>(false);

  //This list is initiated at the application Start
  readonly eventLabels = signal<Record<string, string>>({});

  //Contains the JWT for authentication
  authenticatedHeader: HttpHeaders = new HttpHeaders();
  jwtHelper = new JwtHelperService();
  userProfile: string;
  userId = 0;

  constructor(private http: HttpClient) {

    this.initServerConfig();
    this.isLoggedIn.set(this.checkUserisLoggedIn());

    console.log("Starting App using [" + this.currentEnvironment + "] environment.");
    //Get app information
    this.http.get(this.getServerAddress() + '/conf/app-info')
    .subscribe((data: any) => {
      for (const prop in data) {
        if (prop === "releaseNote") {
          this.backEndReleaseNote = data.releaseNote;
        } else if (prop === "version") {
          this.backEndVersion.set(data.version);
        } else {
          this.eventLabels.update(labels => ({ ...labels, [prop]: data[prop] }));
        }
      }
    }, (_) => {
      console.error('ERROR WHILE GETTING APP INFO!');
    });
  }

  checkUserisLoggedIn = (): boolean => {
    try {
      const tokenJWT = sessionStorage.getItem("token");
      const tokenNotExpired: boolean =  tokenJWT !== null &&  !this.jwtHelper.isTokenExpired(tokenJWT);

      return tokenNotExpired === true &&
       this.getStoredUserId() !== null &&
        this.getStoredUserLogin() !== null;
    } catch (error) {
      console.log("catch", error);
      return false;
    }
  }

  initServerConfig = () => {
    const envName: string = (window as { [key: string]: any })["_env"]?.name as string || 'LOCAL';
    this.currentEnvironment = envName;
    this.currentVersion+='/'+envName;

    this.backEndUrl = (window as { [key: string]: any })["_env"]?.backEndUrl as string || this.localAddress;
  }

  getServerAddress = (): string => {
    return this.backEndUrl;
  }

  convertPassword = (pwd: string, salt: string): string => {
    const value = salt + "%" + pwd;
    const wordArray = CryptoJS.enc.Utf8.parse(value);
    return CryptoJS.MD5(wordArray).toString();
  }

  getVersion = (): string => {
    return this.currentVersion
  }

  changeHeaderName = (name: string) => {
    this.pageName.set(name);
  }

  tellChildContainsTabs = (containsTabs: boolean) => {
    this.containsTabs.set(containsTabs);
  }

  tellActionIsInProgress = (inProgress: boolean) => {
    this.actionInProgress.set(inProgress);
  }

  changeAvatar = (avatarUrl: string) => {
    sessionStorage.setItem('user_avatar', avatarUrl + '');
    this.avatar.set(avatarUrl);
  }

  getStoredUserAvatar = (): string => {
    return sessionStorage.getItem("user_avatar");
  }

  getStoredToken = (): string => {
    return sessionStorage.getItem("token");
  }

  getStoredUserLogin = (): string => {
    return sessionStorage.getItem("user_login");
  }

  getStoredUserId = (): string => {
    const userId =  sessionStorage.getItem("userId");
    if (!userId || userId === '0') {
      return null;
    } else {
      return userId;
    }
  }

  getStoredUserProfile = (): string => {
    this.userProfile=sessionStorage.getItem("userProfile");
    return this.userProfile;
  }

  isAdmin = () : boolean =>  {
    return ['ADMIN'].includes(this.getStoredUserProfile());
  }

  isEventManager = () : boolean =>  {
    return ['ADMIN', 'EVENT_MANAGER'].includes(this.getStoredUserProfile());
  }

  isManager = (): boolean => {
    return ['ADMIN', 'MANAGER'].includes(this.getStoredUserProfile());
  }

  generateRandomString = (length: number): string => {
    const forbiddenValue = Array.of(58,59,60,61,62,63,64,91,92,93,94,95,96);
    let salt = "";
    for (let i = 0; i < length; i++) {
      let value = 0;
      do {
        value = Math.floor(Math.random() * (122 - 48 + 1)) + 48;
      } while (forbiddenValue.includes(value))
      salt += String.fromCharCode(value);
      salt.concat(String.fromCharCode(value));
    }
    return salt;
  }
}
